<div class="top">
	<div [innerHtml]="content"></div>
</div>
